/* ============================================================
   sb-downloads.js — Klick-Tracking fuer sb-download-list
   ============================================================
   Herkunft: das Inline-<script> aus dem custom-liquid-Block auf
   templates/page.downloads.json, unveraendertes dataLayer-Format,
   damit die Auswertung ueber den Umbau hinweg vergleichbar bleibt.

   Zwei Dinge, die beim Auslagern zwingend dazugehoeren:

   1. Idempotenz-Guard. Ein Inline-Skript laeuft bei jedem
      Section-Reload im Theme-Editor neu, eine Datei in assets/
      laeuft genau einmal — ohne Guard wuerden Listener doppelt
      haengen.
   2. shopify:section:load. Ohne den Listener sind Sections nach
      dem ersten Setting-Wechsel im Editor tot.

   Todo-Zeilen ohne URL rendert die Section als <span>, nicht als
   <a>. Der Selektor greift deshalb nur auf echte Links — eine
   Klassen-Pruefung wie im alten Inline-Skript braucht es nicht
   mehr.
   ============================================================ */

(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    root.querySelectorAll('a[data-download-track]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'download_click',
          download_name: link.getAttribute('data-download-track'),
          download_url: link.getAttribute('href'),
          download_cta: link.textContent.trim(),
        });
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-section-type="sb-download-list"]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
